import {t} from './i18n.js';
import * as state from './state.js';

// IT12470760153 (testing)

function init() {
  registerVatChangeListener();
  updateVatTitle();
}

function updateVatTitle() {
  const current_currency = state.getCurrency().toUpperCase();
  if (current_currency === 'GBP') {
    var vat_title = document.querySelector('#sal-vat-title');
    if (vat_title === null) return;

    vat_title.innerHTML = 'Have VAT Number?';

    var vat_title_tooltip = document.querySelector('#sal-vat-title-tooltip');
    vat_title_tooltip.style.display = 'none';
  }
}

function registerVatChangeListener() {
  const checkbox = document.querySelector('.sal-vat-checkbox');
  if (checkbox === null) {
    return;
  }  // not all pages have VAT elements.

  const vat_section = document.querySelector('.sal-vat');
  if (vat_section === null) {
    throw new Error('.sal-vat is required.');
  }

  const current_currency = state.getCurrency().toUpperCase();
  if (current_currency !== 'GBP' && current_currency !== 'EUR') {
    return;
  }  // only show VAT on GBP and EUR carts.

  const submit_button = document.querySelector('.sal-vat-submit');
  if (submit_button === null) {
    throw '.sal-vat-submit is required';
  }

  const text_box = document.querySelector('.sal-vat-textbox');
  if (text_box === null) {
    throw '.sal-vat-textbox is required';
  }

  const info_text = document.querySelector('.sal-vat-company');
  if (info_text === null) {
    throw '.sal-vat-company is required';
  }

  const popover = document.querySelector('.sal-vat-popover');
  if (popover === null) {
    throw '.sal-vat-popover is required';
  }

  const cancel = document.querySelector('.sal-vat-cancel');
  if (cancel === null) {
    throw '.sal-vat-cancel is required';
  }  // if we already have a valid VAT #, fill in the text box and info line

  vat_section.style.display = 'flex';

  let popover_visible = false;
  let popover_busy = false;

  cancel.style.display = 'none';

  checkbox.addEventListener('click', (event) => {
    event.preventDefault();
    if (popover_visible) {
      popover.style.display = 'none';
    } else {
      popover.style.display = 'block';
      text_box.focus();
    }
    popover_visible = !popover_visible;
  }, false);

  document.addEventListener('click', (event) => {
    if (popover_visible === false) {
      return;
    }
    if (popover_busy === true) {
      return;
    }
    if (event.target === checkbox) {
      return;
    }
    if (popover.contains(event.target)) {
      return;
    }

    popover.style.display = 'none';
    popover_visible = false;
  }, false);

  text_box.addEventListener('keydown', (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      submit_button.click();
    }
  }, false);

  cancel.onclick = function(event) {
    info_text.textContent = '';
    checkbox.checked = false;

    state.setVatState(null);

    checkbox.disabled = false;
    text_box.disabled = false;
    text_box.classList.remove('sal-vat-valid');
    submit_button.disabled = false;
    cancel.style.display = 'none';
  };

  const vatState = state.getVatState();
  if (vatState !== null) {
    const vat_number = vatState.number;
    const vat_company = vatState.company;

    checkbox.checked = true;
    text_box.value = vat_number;
    info_text.textContent = `${vat_company}`;

    text_box.disabled = true;
    text_box.classList.add('sal-vat-valid');
    submit_button.disabled = true;

    cancel.style.display = 'block';
  } else {
    checkbox.checked = false;
    text_box.classList.remove('sal-vat-valid');
    cancel.style.display = 'none';
  }

  submit_button.onclick = function(event) {
    const vat_number = text_box.value;
    if (vat_number.length === 0) {
      return;
    }

    popover_busy = true;
    checkbox.disabled = true;
    text_box.disabled = true;
    submit_button.disabled = true;

    state.verifyVatNumberAndSaveVatState(vat_number)
        .then((vatState) => {
          if (vatState !== null) {
            const companyName = vatState.company ? vatState.company : 'VAT';
            info_text.textContent = `Valid - ${companyName}`;
            checkbox.checked = true;
            checkbox.disabled = false;
            text_box.disabled = true;
            text_box.classList.add('sal-vat-valid');
            submit_button.disabled = true;
            cancel.style.display = 'block';
          } else {
            info_text.textContent = t('js-vat-invalid');
            checkbox.checked = false;
            checkbox.disabled = false;
            text_box.disabled = false;
            submit_button.disabled = false;
            cancel.style.display = 'none';
          }

          popover_busy = false;
        })
        .catch((err) => {
          console.log(err);

          info_text.textContent = t('js-vat-trouble');

          text_box.disabled = false;
          submit_button.disabled = false;
        });
  };
}


function getCheckoutTaxMessage() {
  const currency = state.getCurrency();       // upper case
  const country_iso = state.getCountryIso();  // upper case

  if (currency === 'USD' && country_iso === 'US') return null;
  if (currency === 'USD') return t('js-checkout-international-info');
  if (currency === 'CAD') return t('js-checkout-ca-info');
  if (currency === 'JPY') return t('js-checkout-jp-info');
  if (currency === 'AUD') return t('js-checkout-au-info');
  if (currency === 'CNY') return t('js-checkout-zh-info');
  if (currency === 'TWD') return t('js-checkout-tw-info');
  if (currency === 'GBP') return t('js-checkout-uk-info');
  if (currency === 'EUR') return t('js-checkout-eu-info');

  throw `currency ${currency} appears invalid`;
}

function getCartTaxMessage() {
  const currency = state.getCurrency();       // upper case
  const country_iso = state.getCountryIso();  // upper case

  if (currency === 'USD' && country_iso === 'US') return null;
  if (currency === 'USD') return t('js-cart-international-info');
  if (currency === 'CAD') return t('js-cart-ca-info');
  if (currency === 'JPY') return t('js-cart-jp-info');
  if (currency === 'AUD') return t('js-cart-au-info');
  if (currency === 'CNY') return t('js-cart-zh-info');
  if (currency === 'TWD') return t('js-cart-tw-info');
  if (currency === 'GBP') return t('js-cart-uk-info');
  if (currency === 'EUR') return t('js-cart-eu-info');

  throw `currency ${currency} appears invalid`;
}

function getCartTaxMessagePopover() {
  const currency = state.getCurrency();       // upper case
  const country_iso = state.getCountryIso();  // upper case

  if (currency === 'USD' && country_iso === 'US') return null;
  if (currency === 'USD') return t('js-cart-international-info-ex');
  if (currency === 'CAD') return t('js-cart-ca-info-ex');
  if (currency === 'JPY') return t('js-cart-jp-info-ex');
  if (currency === 'AUD') return t('js-cart-au-info-ex');
  if (currency === 'CNY') return t('js-cart-zh-info-ex');
  if (currency === 'TWD') return t('js-cart-tw-info-ex');
  if (currency === 'GBP') return t('js-cart-uk-info-ex');
  if (currency === 'EUR') return t('js-cart-eu-info-ex');

  throw `currency ${currency} appears invalid`;
}

export {
  init,
  getCheckoutTaxMessage,
  getCartTaxMessage,
  getCartTaxMessagePopover,
};